import {CSSProperties, ReactNode} from "react";
import splitLayoutStyles from './split-layout.module.css'

export type SplitLayoutProps = {
    children: ReactNode,
    leftFixed?: number,
    rightFixed?: number,
    leftFraction?: number,
    rightFraction?: number,
    centerItems?: boolean
    style?:CSSProperties
}

const verifyProps = (splitLayoutProps: SplitLayoutProps) => {
    const {leftFixed, rightFixed, leftFraction, rightFraction} = splitLayoutProps
    if (leftFixed && rightFixed) {
        throw new Error('Cannot have both leftFixed and rightFixed in SplitLayout')
    }
    if ((leftFixed || rightFixed) && (leftFraction || rightFraction)) {
        throw new Error('Cannot have both fixed values and fraction values in SplitLayout')
    }
}

const calculateColumns = (leftValue?: string, rightValue?: string) => {
    return {
        gridTemplateColumns: `${leftValue ?? "minmax(0,1fr)"} ${rightValue ?? "minmax(0,1fr)"}`
    }
}

const calculateValue = (fixedValue?: number, fractionValue?: number) => {
    const _fixedValue = fixedValue ? `${fixedValue}px` : undefined;
    const _fractionValue = fractionValue ? `${fractionValue}fr` : undefined;
    return _fixedValue ?? _fractionValue
}

const calculateCenterItemsStyles = (centerItems?: boolean) => {
    return {
        alignItems: centerItems ? "center" : undefined
    }
}

const calculateGridStyles = (props: SplitLayoutProps) => {
    verifyProps(props)
    const leftValue = calculateValue(props.leftFixed, props.leftFraction)
    const rightValue = calculateValue(props.rightFixed, props.rightFraction)
    const columnStyles = calculateColumns(leftValue, rightValue)
    return {
        ...columnStyles,
        ...calculateCenterItemsStyles(props.centerItems),
        ...props.style
    }
}

export const SplitLayout = (props: SplitLayoutProps) => {
    return (
        <div className={splitLayoutStyles.splitLayout}
             style={calculateGridStyles(props)}>
            {props.children}
        </div>
    )
}
